import { SET_LOGGERS } from '../constants/actionTypes';

const loggers = (state = {}, action) => {
  switch (action.type) {
    case SET_LOGGERS:
      return { ...action.payload };
    default:
      return state;
  }
};

export default loggers;



// WEBPACK FOOTER //
// ./src/redux/loggers.js